import {tenantModule} from "./tenantModule";
import {IHttpService} from "angular";
import gatewayServer from "../gatewayServer";

export class TenantService {
    constructor(private $http: IHttpService) {
        "ngInject";
    }

    isNeedFill() {
        return this.$http.get<boolean>(gatewayServer.getServiceUrl("tenant.need-fill"))
            .then(response => response.data)
    }
}

tenantModule.service("tenantService", TenantService)